// extracted by mini-css-extract-plugin
export default {"container":"Experience_container__5alDG","details":"Experience_details__-6Gsp","image":"Experience_image__-rtvm"};